<template>
  <div>
    <v-tabs slot="extension" height="36" v-model="tabActiva" centered color="white lighten-2" slider-color="#0BBAD9">
      <v-tab v-for="item in opciones" :key="item.texto" class="px-2" :disabled="!item.visible">
        <img v-if="item.logo" :src="item.logo" alt="Escudo"
          style="height: 20px; width: 20px; object-fit: contain; margin-right: 8px;">
        {{ item.texto }}
      </v-tab>
    </v-tabs>

    <div style="height: 2px; background-color:#f2f2f2; width: 100%;"></div>

    <div :key="tabActiva" v-if="comentariosPrePartido.length > 0">
      <ItemComentario v-for="comentario in comentariosPrePartido" :key="comentario.id" :titulo="comentario.title"
        :created="comentario.created" :cantidad-respuestas="comentario.cantidadRespuestas"
        :departamento="comentario.departamento" :partido-id="partidoId" :detail-id="comentario.id"
        :conversacion="tabActiva" @clickDetalle="$emit('goDetailComentarioPartido', arguments[0], arguments[1])">
      </ItemComentario>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; gap: 8px; margin-top: 15px;" v-else>
      <v-icon>chat_bubble</v-icon>
      <span>No hay comentarios</span>
    </div>
    <footer class="tarjeta-footer" v-if="cardType === 'comentarios' && $store.getters.isSafRole">
      <!--       <div style="border-bottom: #D2C8C8 solid 0.5px; margin-top: 15px; margin-bottom: 3px;"></div>
 -->
      <div class="container-buttons">
        <v-btn icon @click="newComentarioPrePartido()" color="primary">
          <v-icon>add</v-icon></v-btn>
      </div>
    </footer>

  </div>
</template>

<script>
import ItemComentario from './ItemComentario.vue'
export default {
  data () {
    return {
      fecha: null,
      hora: null,
      tabActiva: 2,
      comentariosPrePartido: []
    }
  },
  components: {
    ItemComentario
  },
  props: {
    autor: null,
    createdAt: null,
    clubId: null,
    partido: null,
    partidoId: null,
    departamento: null,
    estado: null,
    detailId: null,
    reportType: null,
    cardType: null,
    modified: null,
    titulo: null,
    localData: null,
    visitorData: null
  },
  methods: {
    goDetail () {
      this.$router.push({ name: 'informe-auditoria', params: { id: this.detailId } })
    },
    formatDateTime () {
      let dateTime = this.createdAt.split('T')
      this.fecha = dateTime[0]
      const [dia, mes, anio] = this.fecha.split('-')
      this.fecha = `${anio}-${mes}-${dia}`
      this.hora = dateTime[1].split('.')[0]
    },
    fetchComentariosPrePartido () {
      this.axios
        .get(`informe-auditoria/comentarios-pre-partido?partido=${this.partidoId}&conversacion=${this.tabActiva}`)
        .then(response => {
          this.comentariosPrePartido = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    newComentarioPrePartido () {
      const tabSeleccionada = this.opciones.find(opcion => opcion.valor === this.tabActiva)
      const nombreClub = tabSeleccionada ? tabSeleccionada.clubNombre : ''
      this.$emit('createComentarioPrePartido', this.tabActiva, nombreClub)
    },
    setTabInicial () {
      if (this.$store.getters.isSafRole) {
        this.tabActiva = 2
        return
      }

      const miClub = this.$store.state.club

      if (this.localData && miClub === this.localData.nombre) {
        this.tabActiva = 0
      } else if (this.visitorData && miClub === this.visitorData.nombre) {
        this.tabActiva = 1
      } else {
        this.tabActiva = 2
      }
    }
  },
  computed: {
    opciones () {
      let todasLasOpciones = null
      if (this.$store.getters.isSafRole) {
        todasLasOpciones = [
          {
            texto: 'Local',
            logo: this.localData ? this.localData.logo : null,
            valor: 0,
            visible: true,
            clubNombre: this.localData ? this.localData.nombre : ''
          },
          {
            texto: 'Visitante',
            logo: this.visitorData ? this.visitorData.logo : null,
            valor: 1,
            visible: true,
            clubNombre: this.visitorData ? this.visitorData.nombre : ''
          },
          {
            texto: 'Ambos',
            logo: null,
            valor: 2,
            visible: true,
            clubNombre: 'Ambos clubes'
          }
        ]
      } else {
        todasLasOpciones = [
          {
            texto: 'Local',
            logo: this.localData ? this.localData.logo : null,
            valor: 0,
            visible: this.localData ? this.$store.state.club === this.localData.nombre : false,
            clubNombre: this.localData ? this.localData.nombre : ''
          },
          {
            texto: 'Visitante',
            logo: this.visitorData ? this.visitorData.logo : null,
            valor: 1,
            visible: this.visitorData ? this.$store.state.club === this.visitorData.nombre : false,
            clubNombre: this.visitorData ? this.visitorData.nombre : ''
          },
          {
            texto: 'Ambos',
            logo: null,
            valor: 2,
            visible: true,
            clubNombre: 'Ambos clubes'
          }
        ]
      }

      return todasLasOpciones
    }
  },
  watch: {
    tabActiva (nuevoValor, valorAnterior) {
      this.fetchComentariosPrePartido()
    },
    immediate: true
  },
  created () {
    // this.formatDateTime()
    this.setTabInicial()
    this.fetchComentariosPrePartido()
  }
}
</script>

<style scoped>
.tarjeta {
  background-color: #eeeeee;
  width: 90%;
  height: 60px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
}

span {
  font-size: 1.2em;
  color: #293968;
}

.container-titulo-informe,
.container-autor {
  justify-items: center;
}

.container-autor {
  margin-right: 20px;
}

.container-titulo-informe {
  margin-left: 20px;
}

.tarjeta-selection {
  margin-right: 20px;
  cursor: pointer;
}

.container-buttons {
  align-content: center;
  display: flex;
  justify-content: center;
}
</style>
